import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

import SafelyRenderHtml from '@src/services/renderEditorText';

const FooterSection = ({ id, section }) => {
    let body = null;
    if (section.text) {
        body = (
            <div className="footer_bodytext">
                { SafelyRenderHtml(section.text) }
            </div>
        );
    } else if (section.links) {
        body = (
            <div id={id} className="footer-links">
                {
                    section.links.map((link) => {
                        if (link.external) {
                            return (
                                <a
                                    key={link.href}
                                    href={link.href}
                                    className="external-link white-icon"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    { link.title }
                                </a>
                            );
                        }

                        return (
                            <Link
                                key={link.href}
                                to={link.href}
                            >
                                { link.title }
                            </Link>
                        );
                    })
                }
            </div>
        );
    }

    const colSize = section.id === 'links' ? 8 : 4;

    return (
        <Col md={colSize}>
            <h3 className="footer_title" aria-label={section.title}>
                { section.title }
            </h3>
            { body }
        </Col>
    );
};

FooterSection.propTypes = {
    id: PropTypes.string,
    section: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        links: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string.isRequired,
            title: PropTypes.string,
            external: PropTypes.bool,
        })),
    }),
};

export default FooterSection;
